import type { z } from 'zod';

import { statusMutationSchema } from '@/_schemas/status-input';

import { locationQuerySchema } from './location-query-schema';

export const locationUpdateSchema = locationQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: statusMutationSchema });
export type LocationUpdateSchema = z.infer<typeof locationUpdateSchema>;

export const locationCreateSchema = locationUpdateSchema.pick({ name: true, status: true });
export type LocationCreateSchema = z.infer<typeof locationCreateSchema>;
